// extracted by mini-css-extract-plugin
export default {"productcard":"YI","productimage":"ZI","username":"aJ","multiBagName":"bJ","productinfo":"cJ","productinfoinner":"eJ","productname":"fJ","productsubheader":"gJ","productdescription":"hJ","productnumbers":"iJ","productnumberstitle":"jJ","productnumbersitem":"kJ","number":"lJ","numbertext":"mJ","tabs":"nJ","benefitsblock":"oJ","benefit":"pJ","benefitname":"qJ","benefitdescription":"rJ","ingredientsblock":"sJ","tipsblock":"tJ","mobileonly":"uJ"};
    if(module.hot) {
      // 1737143662179
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  